<template>
  <span class="ajuda-impressao">
    <i :id="id" class="fa fa-question-circle" tabindex="0"></i>
    <b-popover :target="id" triggers="hover focus" placement="auto" custom-class="ajuda-impressao-popover">
      <template #title>{{ ajuda.titulo }}</template>
      <div class="resumo">{{ ajuda.resumo }}</div>
      <ul v-if="ajuda.detalhes && ajuda.detalhes.length">
        <li v-for="(d, i) in ajuda.detalhes" :key="i">{{ d }}</li>
      </ul>
      <div v-for="(ex, i) in ajuda.exemplos || []" :key="'ex' + i" class="exemplo">
        <div class="exemplo-titulo">{{ ex.titulo }}</div>
        <pre>{{ ex.texto }}</pre>
      </div>
    </b-popover>
  </span>
</template>

<script>
// Icone (?) com a explicacao da opcao e um exemplo de como sai no papel.
export default {
  props: {
    ajuda: { type: Object, required: true },
  },
  computed: {
    id() {
      return `ajuda-impressao-${this._uid}`;
    },
  },
};
</script>

<style lang="scss" scoped>
.ajuda-impressao i {
  color: #6c757d;
  cursor: help;
  margin-left: 4px;
}
</style>

<style lang="scss">
.ajuda-impressao-popover {
  max-width: 420px;
  font-size: 12px;
  .resumo {
    font-weight: bold;
    margin-bottom: 4px;
  }
  ul {
    padding-left: 16px;
    margin-bottom: 6px;
  }
  .exemplo-titulo {
    font-weight: bold;
    margin-top: 6px;
  }
  pre {
    background: #fffdf5;
    border: 1px dashed #ccc;
    padding: 6px;
    margin: 2px 0 0;
    font-size: 10px;
    line-height: 1.25;
    white-space: pre;
    overflow-x: auto;
  }
}
</style>
